import { Directive, OnInit, OnDestroy, Input } from '@angular/core';
import { DataBindingDirective, GridComponent } from '@progress/kendo-angular-grid';
import { Subscription } from 'rxjs';
import { GridSettings } from '../_helpers/gridSettings';
import { ListService } from '../_services/list.service';
import { StatePersistingService } from '../_services/state-persisting.service';
import { ListAssetService } from '../_services/list-asset.service';
import { ColumnSettings } from '../_helpers/columnSettings';
import { ListAssetByAccountNoService } from '../_services/list-asset-by-account-no.service';

@Directive({
  selector: '[appAMSBindingSearchAssetAccountNo]'
})
export class TableDataSearchAssetByAccountNoDirective extends DataBindingDirective implements OnInit, OnDestroy {
  @Input('appAMSBindingSearchAssetAccountNo') TableName: string;
  @Input() param1: string;
  @Input() param2: string;
  @Input() param3: string;
  @Input() param4: string;
  @Input() param5: string;
  private serviceSubscription: Subscription;
  public gridSettings: GridSettings;
  private refreshSubscription: Subscription;
  constructor(private lists: ListAssetByAccountNoService, grid: GridComponent, public persistingService: StatePersistingService) {
    super(grid);
  }
  public get savedStateExists(): boolean {
    return !!this.persistingService.get('gridSettings');
  }
  public ngOnInit(): void {
    this.lists.tableName = this.TableName;
    this.lists.param1 = this.param1;
    this.lists.param2 = this.param2;
    this.lists.param3 = this.param3;
    this.lists.param4 = this.param4;
    this.lists.param5 = this.param5;
    const gridSettings: GridSettings = this.persistingService.get(this.TableName + 'gridSettings');

    if (gridSettings !== null) {
      this.gridSettings = this.mapGridSettings(gridSettings);
      this.state = this.gridSettings.state;
    }
    this.serviceSubscription = this.lists.subscribe((result) => {
      this.gridSettings = this.persistingService.get(this.TableName + 'gridSettings');
      this.grid.loading = false;
      this.grid.data = result;
      if (this.gridSettings !== null) {
        this.gridSettings = this.mapGridSettings(this.gridSettings);
        this.grid.columns.forEach((column) => {
          this.gridSettings.columnsConfig.forEach((config) => {
            if (column.title === config.title) {
              column.orderIndex = config.orderIndex;
              column.hidden = config.hidden;
            }
          });
        });
      }
      this.notifyDataChange();
    });

    super.ngOnInit();

    this.intitialRebind();

    this.refreshSubscription = this.lists.refreshTrigger.subscribe((tableName: string) => {
      this.rebind();
    });
  }

  public ngOnDestroy(): void {
    if (this.serviceSubscription) {
      this.serviceSubscription.unsubscribe();
    }
    if (this.refreshSubscription) {
      this.refreshSubscription.unsubscribe();
    }
    this.saveGridSettings(this.grid);
    super.ngOnDestroy();
  }
  public intitialRebind() {
    this.grid.loading = true;
    this.lists.query(this.state);
  }

  public rebind(): void {
    this.grid.loading = true;
    this.saveGridSettings(this.grid);
    this.lists.query(this.state);
  }

  saveGridSettings(grid: GridComponent): void {
    const columns = grid.columns;

    //    const gridConfig = {
    //      state: this.state,
    //      columnsConfig: columns.toArray().map(item =>
    //        Object.keys(item)
    //          .filter(propName => !propName.toLowerCase().includes('template'))
    //          .reduce((acc, curr) => ({ ...acc, ...{ [curr]: item[curr] } }), <ColumnSettings>{})
    //      )
    //  };

    const gridConfig = {
      state: this.state,
      columnsConfig: columns.toArray().map((item) => {
        return <ColumnSettings>{
          field: item['field'],
          width: item['width'],
          _width: item['_width'],
          title: item['title'],
          filter: item['filter'],
          format: item['format'],
          filterable: item['filterable'],
          orderIndex: item['orderIndex'],
          hidden: item['hidden'],
        };
      }),
    };

    this.persistingService.set(this.TableName + 'gridSettings', gridConfig);
  }
  public mapGridSettings(gridSettings: GridSettings): GridSettings {
    const state = gridSettings.state;
    if (state.filter !== undefined) {
      this.mapDateFilter(state.filter);
    }

    return {
      state,
      columnsConfig: gridSettings.columnsConfig.sort((a, b) => a.orderIndex - b.orderIndex),
    };
  }
  private mapDateFilter = (descriptor: any) => {
    const filters = descriptor.filters || [];
    filters.forEach((filter) => {
      if (filter.filters) {
        this.mapDateFilter(filter);
      } else if (filter.value) {
        if (this.isDate(filter.value)) {
          filter.value = new Date(filter.value);
        }
      }
    });
  };

  private isDate(input) {
    const timestamp = Date.parse(input);
    if (input && Object.prototype.toString.call(input) === '[object Date]' && !isNaN(input)) {
      return true;
    }
    if (isNaN(timestamp) === false && input.toString().indexOf('T') > -1) {
      return true;
    } else {
      return false;
    }
  }
}
